import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { ShieldCheck, LayoutDashboard, FileSearch, FileText, Receipt, LogOut } from "lucide-react";
import { logoutWarranty } from "@/Calls/callWarrantyAuth";

const NAV = [
    { to: "/warranty/dashboard",       label: "Dashboard",       icon: LayoutDashboard },
    { to: "/warranty/quote-requests",  label: "Quote Requests",  icon: FileSearch     },
    { to: "/warranty/my-quotes",       label: "My Quotes",       icon: FileText       },
    { to: "/warranty/billing",         label: "Billing",         icon: Receipt        },
];

export default function WarrantyLayout() {
    const navigate  = useNavigate();
    const location  = useLocation();

    const handleLogout = async () => {
        await logoutWarranty().catch(() => {});
        navigate("/warranty/login");
    };

    return (
        <div className="min-h-screen flex bg-gray-50">
            <aside className="w-60 bg-purple-700 text-white flex flex-col">
                <div className="px-5 py-5 border-b border-purple-600 flex items-center gap-2">
                    <ShieldCheck className="h-6 w-6 text-purple-200" />
                    <span className="font-semibold text-sm tracking-wide">Warranty Portal</span>
                </div>
                <nav className="flex-1 px-3 py-4 space-y-1">
                    {NAV.map(({ to, label, icon: Icon }) => {
                        const active = location.pathname === to;
                        return (
                            <Link
                                key={to}
                                to={to}
                                className={`flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors ${
                                    active
                                        ? "bg-purple-900/60 text-white font-medium"
                                        : "text-purple-200 hover:bg-purple-600/50 hover:text-white"
                                }`}
                            >
                                <Icon className="h-4 w-4 shrink-0" />
                                {label}
                            </Link>
                        );
                    })}
                </nav>
                <div className="px-3 py-4 border-t border-purple-600">
                    <button
                        onClick={handleLogout}
                        className="flex items-center gap-2.5 w-full px-3 py-2 rounded-lg text-sm text-purple-200 hover:bg-purple-600/50 hover:text-white transition-colors"
                    >
                        <LogOut className="h-4 w-4 shrink-0" />
                        Sign Out
                    </button>
                </div>
            </aside>
            <main className="flex-1 p-6 overflow-y-auto">
                <Outlet />
            </main>
        </div>
    );
}
